import { Injectable } from '@angular/core';
import { ApiService } from '../../services/common/api.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AllApiService {
 constructor(private api: ApiService) {}
  getAccessToken(payload: any): Observable<any> {
    return this.api.post(`${environment.BASE_URL}/api/v1/auth/token`, {
      body: payload,
    });
  }
}
